import { isNil } from 'lodash';

// MUI's Select (v4 and v5 alike) keeps a hidden input for browser autofill whose value is the
// selection serialized as `Array.isArray(value) ? value.join(',') : value`, and the `handleChange`
// behind it ("Support autofill") passes that raw string straight back through `onChange` without
// re-wrapping it in an array — even when `multiple`. It also hands the value to `renderValue`
// before reaching its own `!Array.isArray(value)` throw. Both paths were byte-identical in v4's and
// v5's `Select/SelectInput.js`, so this is not migration debt: it survived the move to
// `@mui/material` unchanged.
//
// Normalize any non-array value back to the array shape at those boundaries so multiple-select
// consumers only ever see arrays. Wrap, never split on ',': that `handleChange` early-returns
// unless the string equals one MenuItem value exactly, so anything reaching us is a single option
// value and never the joined form — splitting would turn an option value that legitimately contains
// a comma ("Smith, John") into two bogus selections.
export const normalizeMultiSelectValue = <V>(value: V[] | V | null | undefined): V[] => {
  if (Array.isArray(value)) return value;
  if (isNil(value) || value === '') return [];
  return [value as V];
};
